/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询剧院自定义楼层和项目数据
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.TheaterFloorDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater-floor/products`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
